import React, { Component } from "react";

export default class Appointment extends Component {
  render() {
    return (
      <div className="appointments-rapper flex">
        <div className="line"></div>
        <div className="date-container">
          <p className="month">{this.props.month}</p>
          <div className="card flex ">
            <p className="date">{this.props.date}</p>
            <p className="day">{this.props.day}</p>
          </div>
        </div>
        <div className="appointments">{this.props.children}</div>
      </div>
    );
  }
}
